import React, { useState } from "react";
import { IconButton, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { statusColorSchema } from "./StatusColorSchema";
import CustomButton from "../../../reusableComponents/CustomButton";
import { extractTextFromHTML } from "../../utils/utils";

export default function timelineScenarios(operation, refundReasons, timezone, approveTransactionRequest, approvalLoader, setIsRejectModal, isAuthorizedPermission) {

  const operationInfo = (message) => {
    return (
      <Tooltip title={message ? extractTextFromHTML(message) : ""} arrow>
        <IconButton
          sx={{
            paddingTop: "2px",
            "&:hover": { backgroundColor: "transparent" },
          }}
          disableFocusRipple
          disableTouchRipple
        >
          <InfoIcon
            sx={{
              height: "14px",
              width: "14px",
              border: "0px",
              color: " var(--text-medium, rgba(1, 1, 2, 0.40))",
            }}
          />
        </IconButton>
      </Tooltip>
    );
  };
  const operationInfoWithoutTooltip = (message) => {
    return (
      <>
        <div style={{ display: "flex", width: "100%" }}>
          <Typography
            className="errorMessageTimeline"
            style={{ marginRight: "4px" }}
          >
            Error Msg: <span className="messageTimeline">{message}</span>
          </Typography>
        </div>
      </>
    );
  };

  let captureRefundTitle = `${operation?.status?.operationLocale} of ${operation?.money?.currencyCode} ${operation?.money?.amountLocaleFull}`;
  // let captureRefundLatestChip = `${operation?.status?.operationLocale} ${operation?.finalStatusLocale}`;
  let captureRefundLatestChip = `${operation?.finalStatusLocale}`;

  let authTitle = `${operation?.status?.operationLocale} of ${operation?.money?.currencyCode} ${operation?.money?.amountLocaleFull}`;
  // let authLatestChip = `${operation?.status?.operationLocale} ${operation?.finalStatusLocale}`;
  let authLatestChip = `${operation?.finalStatusLocale}`;

  let settlementTitle = `${operation?.status?.operationLocale} of ${operation?.money?.currencyCode} ${operation?.money?.amountLocaleFull}`;
  // let settlementLatestChip = `${operation?.status?.operationLocale} ${operation?.finalStatusLocale}`;
  let settlementLatestChip = `${operation?.finalStatusLocale}`;

  let cancleTitle = `Payment ${operation?.status?.operationLocale}`;
  // let cancelLatestChip = `Payment Cancellation ${operation?.finalStatusLocale}`;
  let cancelLatestChip = `${operation?.finalStatusLocale}`;

  const generateTimeLineBody = (
    operationTypeTitle,
    latestStatusTitle,
    toolTip,
    latestStatusTooltip
  ) => {
    return {
      icon: statusColorSchema[operation?.status?.statusLocale]?.icon,
      title: operationTypeTitle,
      btn: (
        <div
          className={`payment-status-btn ${statusColorSchema[operation?.status?.statusLocale]?.background
            }`}
        >
          <Typography
            className={`bodyB2Medium ${statusColorSchema[operation?.status?.statusLocale]?.text
              }`}
          >
            {operation?.finalStatusLocale}
          </Typography>
        </div>
      ),
      subtitle: (
        <div>
          <Typography className="labelRegularColored">
            {operation?.receivedOnLocale}
          </Typography>
          {operation?.status?.reason && operation?.status?.status?.toLowerCase() == "declined" &&
            <div>
              <div style={{ display: "flex" }}>
                <Typography className="labelMedium" sx={{ marginRight: "4px" }}>
                  Initiated by:
                </Typography>
                <Typography className="labelRegularColored">
                  {operation?.actorId}
                </Typography>
              </div>
              <div style={{ display: "flex" }}>
                <Typography className="labelMedium" sx={{ marginRight: "4px", minWidth: "60px" }}>
                  Remarks:
                </Typography>
                <Typography
                  className="labelRegularColored"
                  dangerouslySetInnerHTML={{ __html: operation?.status?.reason || "" }}
                />
              </div>

            </div>
          }
          {operation?.status?.status?.toLowerCase() == "pendingreview" && operation?.actorId && <div style={{ display: "flex" }}>
            <Typography className="labelMedium" sx={{ marginRight: "4px" }}>
              Initiated by:
            </Typography>
            <Typography className="labelRegularColored">
              {operation?.actorId}
            </Typography>
          </div>}
          {operation?.reviewRequired && isAuthorizedPermission && isAuthorizedPermission("REFUND_REVIEW_PAYMENT") && <div className=" d-flex align-items-center" style={{ marginRight: "4px", gap: "10px", marginTop: "10px" }}>
            <CustomButton sx={{ fontWeight: "600" }} loading={approvalLoader} variant={"contained"} text={"Approve"} type={"primary"} onClick={() => approveTransactionRequest(operation)} />
            <CustomButton sx={{ fontWeight: "600" }} disabled={approvalLoader} variant={"outlined"} text={"Deny"} type={"primary"} onClick={() => setIsRejectModal(operation)} />
          </div>}
          {operation?.pspCodeLocale && (
            <div style={{ display: "flex" }}>
              <Typography className="labelMedium" sx={{ marginRight: "4px" }}>
                PSP:
              </Typography>

              <Typography className="labelRegularColored">
                {operation?.pspCodeLocale}
              </Typography>
            </div>
          )}
          {operation?.pspReference && (
            <div style={{ display: "flex" }}>
              <Typography className="labelMedium" sx={{ marginRight: "4px" }}>
                PSP Reference ID:
              </Typography>

              <Typography className="labelRegularColored">
                {operation?.pspReference}
              </Typography>
            </div>
          )}
          {operation?.authCode && (
            <div style={{ display: "flex" }}>
              <Typography className="labelMedium" sx={{ marginRight: "4px" }}>
                Bank Reference:
              </Typography>

              <Typography className="labelRegularColored">
                {operation?.authCode}
              </Typography>
            </div>
          )}
          {(operation?.status?.status === "Failed" ||
            operation?.status?.status === "Rejected") &&
            operationInfoWithoutTooltip(operation?.status?.reason)}
        </div>
      ),
      info:
        operation?.status?.status === "Approved" ||
          operation?.status?.status === "Failed" ||
          operation?.status?.status === "Rejected"
          ? operation?.status?.operation === "Refund" ||
            operation?.status?.operation === "Partial_Refund"
            ? operation?.additionalData?.refundReason
              ? operationInfo(
                refundReasons?.find(
                  (ele) =>
                    ele?.name == operation?.additionalData?.refundReason
                )?.label
              )
              : " "
            : " "
          : toolTip,
      latestStatusInfo: latestStatusTooltip,
      latestStatusLabel: latestStatusTitle,
    };
  };

  let timelineDict = {
    Partial_Capture: generateTimeLineBody(
      captureRefundTitle,
      captureRefundLatestChip,
      operationInfo(operation?.status?.reason),
      operationInfo(operation?.status?.reason)
    ),

    Capture: generateTimeLineBody(
      captureRefundTitle,
      captureRefundLatestChip,
      operationInfo(operation?.status?.reason),
      operationInfo(operation?.status?.reason)
    ),

    Partial_Refund: generateTimeLineBody(
      captureRefundTitle,
      captureRefundLatestChip,
      operationInfo(operation?.status?.reason),
      operationInfo(operation?.status?.reason)
    ),

    Refund: generateTimeLineBody(
      captureRefundTitle,
      captureRefundLatestChip,
      operationInfo(operation?.status?.reason),
      operationInfo(operation?.status?.reason)
    ),

    Cancel: generateTimeLineBody(
      cancleTitle,
      cancelLatestChip,
      operationInfo(operation?.status?.reason),
      operationInfo(operation?.status?.reason)
    ),

    Authorisation: generateTimeLineBody(
      authTitle,
      authLatestChip,
      operationInfo(operation?.status?.reason),
      operationInfo(operation?.status?.reason)
    ),

    Settlement: generateTimeLineBody(
      settlementTitle,
      settlementLatestChip,
      operationInfo(operation?.status?.reason),
      operationInfo(operation?.status?.reason)
    ),

    Default: generateTimeLineBody(
      `${operation?.status?.operationLocale} ${operation?.money?.currencyCode} ${operation?.money?.amountLocaleFull}`,
      `${operation?.status?.operationLocale} ${operation?.status?.statusLocale}`,
      operationInfo(operation?.status?.reason),
      operationInfo(operation?.status?.reason)
    ),
  };

  return !timelineDict[operation?.status?.operation]
    ? timelineDict["Default"]
    : timelineDict[operation?.status?.operation];
}
